import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as moment from 'moment';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Dialog } from 'primeng/dialog';
import { Paginator } from 'primeng/paginator';
import { Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import firebase from 'firebase';
import { environment } from 'src/environments/environment.prod';
import { AppSettings } from '../Constant/AppSettings';
import { CommonFunctions } from '../Utilities/CommonFunctions';
import { ClientDataService } from '../services/client-data/client-data.service';
import { ClientcommunicationService } from '../services/clientcommunication/clientcommunication.service';
import { PrivilegeService } from '../services/privilege/privilege.service';
import { ProfileService } from '../services/profile/profile.service';
import { UtilsService } from '../services/utils/utils.service';

export enum TwilioEmergencyAddressStatus {
  NONE = 'NONE',
  PENDING_ASSIGN = 'PENDING_ASSIGN',
  ASSIGNED = 'ASSIGNED'
}

export enum EinVerificationStatus {
  NONE = 'NONE',
  IN_PROGRESS = 'IN_PROGRESS',
  VERIFIED = 'VERIFIED',
  NOT_SUCCESSFUL = 'NOT_SUCCESSFUL'
}

@Component({
  selector: 'app-client-datamanagement',
  templateUrl: './client-datamanagement.component.html',
  styleUrls: ['./client-datamanagement.component.css']
})
export class ClientDatamanagementComponent implements OnInit {
  @ViewChild('p', { static: false }) paginator?: Paginator;
  items: MenuItem[] = [{ label: 'Client Data Management' }];
  home: MenuItem = { icon: 'pi pi-home', routerLink: '/home' };
  isLoading: boolean = false;
  @Input() id: any;
  noOfData: number = 0;
  businessName: string = '';
  shortName: string = '';
  address: string = '';
  phone: string = '';
  fax = '';
  ein = '';
  einVerificationStatus: string = '';
  websiteUrl = '';
  country = null;
  countries: any[] = [];
  selectedBusinessType: any = 'null';
  businessType: any[] = []
  timezone: string = 'null';
  timezoneList: string[] = [];
  address2: string = '';
  city: string = '';
  business_state: string = '';
  zipcode: string = '';
  twilioNumber: string = '';
  //
  clients: any[] = [];
  searchInputText: string = '';
  successFileName: string = '';
  errorFileName: string = '';
  numErrorRecords: number = 0;
  //Paginator variable
  timer: any;
  pageSize: any = 0;
  currentPage: any = 1;
  totalCount: any = 0;
  private listClientsRequestId = 0;

  // PRIMENG variable
  cols: any[] = [];
  status: any[] = [];
  selectedStatus: any;
  sortField: string = 'name';
  sortDirection: string = 'ASC';
  expiryStatusOptions: any[] = [];
  selectedExpiryStatus: any;
  subscriptionTypeOptions: any[] = [];
  selectedSubscriptionType: any;
  // Dialog display varaible
  headerName: string = '';
  displayAddEditModal: boolean = false;
  displayChangeModal: boolean = false;
  disabled: boolean = false;
  importDisabled: boolean = true;
  public innerWidth: any;
  //File upload
  avatarName = '';
  imageInputError: boolean = false;
  businessProfileUrl = '';
  //image cropper
  croppedImageUrl: any = '';
  //Crop Dialog
  displayCropModal: boolean = false
  //Root user / reset password
  rootUser: any = null;
  rootUserLoading: boolean = false;
  newPassword: string = '';
  confirmPassword: string = '';

  statusConfig: Record<TwilioEmergencyAddressStatus, { label: string; class: string }> = {
    [TwilioEmergencyAddressStatus.NONE]: {
      label: 'Not Verified',
      class: 'status-red'
    },
    [TwilioEmergencyAddressStatus.PENDING_ASSIGN]: {
      label: 'In Progress',
      class: 'status-black'
    },
    [TwilioEmergencyAddressStatus.ASSIGNED]: {
      label: 'Verified',
      class: 'status-green'
    }
  };

  einStatusConfig: Record<EinVerificationStatus, { label: string; class: string; icon: string }> = {
    [EinVerificationStatus.NONE]: {
      label: 'Not Verified',
      class: 'ein-status-red',
      icon: 'pi pi-question-circle'
    },
    [EinVerificationStatus.IN_PROGRESS]: {
      label: 'In Progress',
      class: 'ein-status-black',
      icon: 'pi pi-spin pi-spinner'
    },
    [EinVerificationStatus.VERIFIED]: {
      label: 'Verified',
      class: 'ein-status-green',
      icon: 'pi pi-check-circle'
    },
    [EinVerificationStatus.NOT_SUCCESSFUL]: {
      label: 'Not Successful',
      class: 'ein-status-red',
      icon: 'pi pi-times-circle'
    }
  };

  einValidateLoading: boolean = false;
  originalEin: string = '';
  einHistory: any[] = [];
  einHistoryLoading: boolean = false;

  einTriggerConfig: Record<string, { label: string; icon: string }> = {
    AUTOMATIC: { label: 'Automatic (business registration)', icon: 'pi pi-refresh' },
    MANUAL_ADMIN: { label: 'Admin retry', icon: 'pi pi-user' }
  };

  getEinTriggerConfig(triggeredBy: string) {
    return this.einTriggerConfig[triggeredBy] ?? { label: triggeredBy || 'Unknown', icon: 'pi pi-question-circle' };
  }

  constructor(
    public utils: UtilsService,
    private profileService: ProfileService,
    private clientDataService: ClientDataService,
    private clientcommunicationService: ClientcommunicationService,
    private privilegeService: PrivilegeService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.getCountries();
    this.getBusinessType()
    this.getTimezone()
    this.listClients(this.currentPage, this.searchInputText);
    this.cols = [
      { field: 'name', header: 'Business Name', sortable: true },
      { field: 'shortName', header: 'Short Name', sortable: true },
      { field: 'phone', header: 'Phone', sortable: true },
      { field: 'registrationDate', header: 'Registration Date', sortable: true },
      { field: 'subscriptionType', header: 'Subscription Plan' },
      { field: 'subscriptionDuration', header: 'Monthly/Annual' },
      { field: 'expiry', header: 'Expiry Date' }
    ];
    this.status = [
      { name: 'Active', value: 'yes' },
      { name: 'Inactive', value: 'no' },
    ];
    this.expiryStatusOptions = [
      { name: 'Expiring Soon', value: 'EXPIRING_SOON' },
      { name: 'Expired', value: 'EXPIRED' },
    ];
    this.subscriptionTypeOptions = [
      { name: 'Free', value: 'FREE' },
      { name: 'Basic', value: 'BASIC' },
      { name: 'Standard', value: 'STANDARD' },
    ];
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }


  editClient(userForm: NgForm) {
    this.showProgressBar();
    if (userForm.value.firstName === '') {
      this.showErrorMessage('First Name Field is empty.')
      this.hideProgressBar();
      return;
    } if (userForm.value.middleInitial === '') {
      this.showErrorMessage('Middle Name Field is empty.')
      this.hideProgressBar();
      return;
    } if (userForm.value.lastName === '') {
      this.showErrorMessage('Last Name Field is empty.')
      this.hideProgressBar();
      return;
    } if (userForm.value.phone == '') {
      this.showErrorMessage('Mobile Field is empty.')
      this.hideProgressBar();
      return;
    } if (userForm.value.phone.length <= 9) {
      this.showErrorMessage('Mobile Number should be 10 digits.')
      this.hideProgressBar();
      return;
    } if (userForm.value.country === '') {
      this.showErrorMessage('Please select a country.')
      this.hideProgressBar();
      return;
    }
    let mob = '+1' + this.phone;
    let client = {
      name: this.businessName,
      shortName: this.shortName,
      businessType: {
        id: this.selectedBusinessType,
        name: this.businessType.find(element => element.id == this.selectedBusinessType).name
      },
      address: this.address,
      address2: this.address2,
      city: this.city,
      businessState: this.business_state.toUpperCase(),
      zipcode: this.zipcode,
      country: this.country,
      phone: mob,
      fax: this.fax,
      logo: null,
      website: this.websiteUrl,
      timeZone: this.timezone,
      einNo: this.ein
    }
    var data = { data: JSON.parse(JSON.stringify(client)) };
    console.log('Business Data ---> ' + JSON.stringify(data));
    this.clientDataService.editBusiness(this.id, data).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Edit Business Client Post Response --->> ' + JSON.stringify(json));
        console.log('Status --->> ' + json.response.status);
        if (json.response.status == 'SUCCESS') {
          this.showHideModalDialog('edit_client');
          this.showSuccessToastMsg(json.response.displayMessage);
          this.listClients(this.currentPage, this.searchInputText);
        } else {
          this.showErrorMessage(json.response.displayMessage)
        }
        this.hideProgressBar();
      },
      (error) => {
        console.log(error);
        this.showErrorMessage(AppSettings.ERROR_MSG)
        this.hideProgressBar();
      }
    );
  }



  confirmEnableDisableDialog(user: any, isActive: boolean) {
    console.log('ID --->> ' + user.id);
    this.id = user.id;
    this.messageService.clear();
    this.confirmationService.confirm({
      message: 'Do you want to ' + (isActive ? 'enable' : 'disable') + ' this Business client ?',
      header: (isActive ? 'Enable' : 'Disable') + ' Confirmation',
      icon: isActive ? 'pi pi-check-circle' : 'pi pi-times-circle',
      accept: () => {
        this.enableDisableUser(user, isActive);
      },
      reject: () => {
        this.clients[this.clients.findIndex(a => a.id === user.id)].isActive = !isActive;
      }
    });
  }

  enableDisableUser(user: any, isActive: boolean) {
    this.clientDataService.enableDisableBusiness(user.id, isActive).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Remove Client Response --->> ' + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          this.showSuccessToastMsg(json.response.message)
          this.listClients(this.currentPage, this.searchInputText);
        } else {
          this.showErrorToastMsg(json.response.message);
        }
      },
      (error) => {
        console.log(error);
        this.hideProgressBar()
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
      }
    );
  }

  updateSmsNumber(userForm: NgForm) {
    this.showProgressBar();
    // if (userForm.value.twilioNumber === '') {
    //   this.showErrorMessage('Twilio Number Field is empty.')
    //   this.hideProgressBar();
    //   return;
    // } 
    console.log(this.twilioNumber)
    this.clientDataService.updateSmsNumber(this.id, '+1' + this.twilioNumber).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Update SMS Number Response --->> ' + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          this.showSuccessToastMsg(json.response.message)
          this.showHideModalDialog('assign_client');
          // this.listClients(this.currentPage, this.searchInputText);
          this.hideProgressBar()
        } else {
          this.showErrorToastMsg(json.response.message);
        }
      },
      (error) => {
        console.log(error);
        this.hideProgressBar()
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
      }
    );
  }

  listClients(pageNumber: any, searchValue: any) {
    console.log('page number:' + pageNumber)
    this.isLoading = true;
    const requestId = ++this.listClientsRequestId;
    let sortData = {
      sortBy: this.sortField,
      sortDirection: this.sortDirection
    };
    this.clientDataService.getBusinessList(pageNumber, searchValue, this.selectedStatus, sortData, this.selectedExpiryStatus, this.selectedSubscriptionType).subscribe(
      (response) => {
        if (requestId !== this.listClientsRequestId) {
          // a newer search/filter/page request has already superseded this one
          return;
        }
        var json = JSON.parse(JSON.stringify(response));
        if (json.response.status == 'SUCCESS') {
          this.clients = json.data.map((element: any) => ({
            id: element.id,
            name: element.name,
            shortName: element.shortName,
            businessType: element.businessType,
            address: element.address,
            country: element.country,
            countryName: element.countryName,
            phone: element.phone,
            fax: element.fax,
            logo: element.logo,
            website: element.website,
            einNo: element.einNo,
            timeZone: element.timeZone,
            businessId: element.businessId,
            isActive: element.isActive,
            isSubscribed: element.isSubscribed,
            subscriptionType: this.formatSubscriptionType(element.subscriptionType),
            subscriptionDuration: this.formatSubscriptionDuration(element.subscriptionDuration),
            registrationDate: moment(element.registrationDate).format('Do MMMM YYYY'),
            registrationDateRaw: element.registrationDate || null,
            expiry: element.expiry ? moment(element.expiry).format('Do MMMM YYYY') : null,
            expiryDate: element.expiry || null,
            emergencyStatus: (element.emergencyStatus as TwilioEmergencyAddressStatus) || TwilioEmergencyAddressStatus.NONE,
          }));
          this.pageSize = json.additionalData?.pageSize || 0;
          this.totalCount = json.additionalData?.totalCount || 0;
        } else {
          this.clients = [];
        }
        this.hideProgressBar();
      },
      (error) => {
        if (requestId !== this.listClientsRequestId) {
          return;
        }
        console.log(error);
        this.hideProgressBar();
        this.showErrorToastMsg(AppSettings.ERROR_MSG)
      }
    );
  }


  getClient(client: any, type: string) {
    this.clearFormData();
    console.log('ID --->> ' + client.id);
    this.id = client.id;
    this.showHideModalDialog(type);
    if (type == 'edit_client') {
      this.getRootUser(client.id);
    }
    if (type == 'edit_client' || type == 'assign_client') {
      this.showProgressBar();
      this.clientDataService.getSingleBusiness(client.id).subscribe(
        (response) => {
          var json = JSON.parse(JSON.stringify(response));
          console.log('Get Client Response --->> ' + JSON.stringify(json));
          this.businessName = json.data.name;
          this.shortName = json.data.shortName;
          this.selectedBusinessType = json.data.businessType?.id;
          this.country = json.data.country;
          this.ein = json.data.einNo;
          this.originalEin = json.data.einNo;
          this.einVerificationStatus = json.data.einVerificationStatus;
          this.fax = json.data.fax;
          this.websiteUrl = json.data.website;
          this.country = json.data.country;
          this.timezone = json.data.timeZone
          this.address = json.data.address
          this.address2 = json.data.address2 || '';
          this.city = json.data.city || '';
          this.business_state = json.data.businessState ? json.data.businessState.toUpperCase() : '';
          this.zipcode = json.data.zipcode || '';
          this.phone = json.data.phone?.replace('+1', '');
          this.twilioNumber = json.data.twilioNumber?.replace('+1', '')
          this.imageInputError = false
          this.businessProfileUrl = environment.IMAGE_BASE_URL_BUSINESS_ADMIN + json.data.logo;
          this.hideProgressBar();
        },
        (error) => {
          console.log(error);
          this.showErrorMessage(AppSettings.ERROR_MSG)
          this.hideProgressBar();
        }
      );
      this.loadEinHistory(client.id);
    }
  }

  openChat(client: any) {
    this.showProgressBar();
    this.clientcommunicationService.createSupportRoomRest(client.businessId).subscribe((response: any) => {
      const room = response?.data;
      if (room?.id) {
        this.router.navigate(['client-communication/room/' + room.id]);
      }
      this.hideProgressBar();
    },
    (error: any) => {
      console.log(error);
      this.showErrorToastMsg(AppSettings.ERROR_MSG)
      this.hideProgressBar();
    });
  }

  getRootUser(businessId: any) {
    this.rootUser = null;
    this.rootUserLoading = true;
    this.clientDataService.getRootUser(businessId).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        if (json.response.status == 'SUCCESS') {
          this.rootUser = json.data;
        }
        this.rootUserLoading = false;
      },
      (error) => {
        console.log(error);
        this.rootUserLoading = false;
      }
    );
  }

  resetPassword(resetForm: NgForm) {
    this.showProgressBar();
    if (!this.rootUser || !this.rootUser.id) {
      this.showErrorMessage('Root user not found for this business.')
      this.hideProgressBar();
      return;
    }
    if (resetForm.value.newPassword === '') {
      this.showErrorMessage('Please enter a new password.')
      this.hideProgressBar();
      return;
    }
    if (resetForm.value.newPassword !== resetForm.value.confirmPassword) {
      this.showErrorMessage('Passwords do not match.')
      this.hideProgressBar();
      return;
    }
    var passObj = { password: resetForm.value.newPassword };
    var data = { data: JSON.parse(JSON.stringify(passObj)) };
    this.clientDataService.resetRootUserPassword(this.rootUser.id, this.id, data).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        if (json.response.status == 'SUCCESS') {
          this.showSuccessToastMsg(json.response.message)
          resetForm.reset();
          this.newPassword = '';
          this.confirmPassword = '';
        } else {
          this.showErrorMessage(json.response.displayMessage)
        }
        this.hideProgressBar();
      },
      (error) => {
        console.log(error);
        this.showErrorMessage(AppSettings.ERROR_MSG)
        this.hideProgressBar();
      }
    );
  }

  getRootUserRoles(): string {
    if (!this.rootUser || !this.rootUser.roles) {
      return '';
    }
    return this.rootUser.roles.map((r: any) => r.name).join(', ');
  }

  getCountries() {
    this.profileService.getCountries().subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        if (json.response.status == 'SUCCESS') {
          this.countries = json.data;
        } else {
          this.showErrorMessage(json.response.displayMessage)
        }
      },
      (error) => {
        console.log('There was an error');
        console.log(error);
      }
    );
  }

  getBusinessType() {
    this.clientDataService.getBusinessType().subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log(json.data);
        if (json.response.status == 'SUCCESS') {
          this.businessType = json.data;
        } else {
          this.showErrorMessage(json.response.displayMessage)
        }
      },
      (error) => {
        console.log(error);
        this.showErrorMessage(AppSettings.ERROR_MSG)
        this.hideProgressBar();
      }
    );
  }

  getTimezone() {
    this.clientDataService.getTimezone().subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Business timezone response --> ' + JSON.stringify(json.data));
        if (json.response.status == 'SUCCESS') {
          this.timezoneList = json.data;
        } else {
          this.showErrorMessage(json.response.displayMessage)
        }
      },
      (error) => {
        console.log(error);
        this.showErrorMessage(AppSettings.ERROR_MSG)
        this.hideProgressBar();
      }
    );
  }

  confirmDeleteImageDialog() {
    this.messageService.clear();
    this.confirmationService.confirm({
      message: 'Do you want to delete this image ?',
      header: 'Delete Confirmation',
      icon: 'pi pi-trash',
      accept: () => {
        // this.deleteBusinessLogo();
      }
    });
  }

  fileFailedToLoad(event: any) {
    console.log(event)
    this.imageInputError = true;
    this.businessProfileUrl = 'assets/images/business_2.png'
  }

  hideCropModal(displayCropModal: any) {
    if (displayCropModal !== undefined) {
      this.displayCropModal = displayCropModal;
    }

  }

  croppedImage(imageFile: any) {
    if (imageFile !== undefined) {
      this.croppedImageUrl = imageFile?.croppedImageUrl
      this.businessProfileUrl = imageFile?.base64Value;
      this.imageInputError = false
      // this.uploadBusinessLogo()
    }
  }

  onToggle(event: any, user: any) {
    // this.editKeyword(event.checked, keyword);
    this.confirmEnableDisableDialog(user, event.checked)
  }

  getStatusConfig(status: any): { label: string; class: string } {
    return this.statusConfig[status as TwilioEmergencyAddressStatus]
      ?? this.statusConfig[TwilioEmergencyAddressStatus.NONE];
  }

  getEinStatusConfig(status: any): { label: string; class: string; icon: string } {
    return this.einStatusConfig[status as EinVerificationStatus]
      ?? this.einStatusConfig[EinVerificationStatus.NONE];
  }

  getEinStatusCaption(status: any): string {
    switch (status as EinVerificationStatus) {
      case EinVerificationStatus.VERIFIED:
        return 'This EIN matches IRS records for this business name.';
      case EinVerificationStatus.IN_PROGRESS:
        return 'Checking this EIN against IRS records — refresh to see the result.';
      case EinVerificationStatus.NOT_SUCCESSFUL:
        return 'This EIN could not be matched to this business name in IRS records.';
      default:
        return 'This EIN has not been checked against IRS records yet.';
    }
  }

  canRetryEinValidation(): boolean {
    return this.einVerificationStatus !== EinVerificationStatus.IN_PROGRESS
      && this.einVerificationStatus !== EinVerificationStatus.VERIFIED;
  }

  retryEinValidation() {
    if (!this.id || this.einValidateLoading || !this.canRetryEinValidation()) {
      return;
    }
    this.einValidateLoading = true;

    // The retry endpoint verifies whatever EIN is currently saved on the business
    // record — not whatever's sitting unsaved in this form. If the admin just typed
    // a new EIN but hasn't clicked Update, retrying against the stale saved value
    // would silently check the wrong number. Save the EIN first if it changed,
    // then retry — without touching any other field or closing the dialog.
    if (this.ein !== this.originalEin) {
      const einUpdate = { data: { einNo: this.ein } };
      this.clientDataService.editBusiness(this.id, einUpdate).subscribe(
        () => {
          this.originalEin = this.ein;
          this.callValidateEin();
        },
        (error) => {
          console.log(error);
          this.einValidateLoading = false;
          this.showErrorMessage('Could not save the updated EIN before retrying verification.');
        }
      );
    } else {
      this.callValidateEin();
    }
  }

  private callValidateEin() {
    const currentAdmin = CommonFunctions.getUser();
    const adminLabel = [currentAdmin?.firstName, currentAdmin?.lastName].filter(Boolean).join(' ')
      || currentAdmin?.email || 'System Admin';
    this.clientDataService.validateEin(this.id, adminLabel).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        this.einValidateLoading = false;
        if (json.response.status == 'SUCCESS') {
          this.einVerificationStatus = EinVerificationStatus.IN_PROGRESS;
          this.showSuccessToastMsg('EIN verification started, checking for the result...');
          this.loadEinHistory(this.id);
          this.pollEinStatus(this.id);
        } else {
          this.showErrorMessage(json.response.displayMessage)
        }
      },
      (error) => {
        console.log(error);
        this.einValidateLoading = false;
        this.showErrorMessage(AppSettings.ERROR_MSG)
      }
    );
  }

  /**
   * verifyEin() on the backend runs async — the retry call returns before the real
   * result is known. There's no live-update/socket push for this yet, so poll for
   * a few seconds until the status leaves IN_PROGRESS, rather than leaving the
   * spinner running forever until the admin manually reopens the dialog.
   */
  private pollEinStatus(businessId: any, attemptsLeft: number = 6) {
    if (attemptsLeft <= 0 || this.id !== businessId) {
      // Either gave up, or the admin has since switched to a different business's
      // dialog — don't clobber whatever's showing now with a stale result.
      return;
    }
    setTimeout(() => {
      if (this.id !== businessId) {
        return;
      }
      this.clientDataService.getSingleBusiness(businessId).subscribe(
        (response) => {
          var json = JSON.parse(JSON.stringify(response));
          if (json.response.status == 'SUCCESS' && json.data
              && json.data.einVerificationStatus
              && json.data.einVerificationStatus !== EinVerificationStatus.IN_PROGRESS) {
            if (this.id === businessId) {
              this.einVerificationStatus = json.data.einVerificationStatus;
              this.loadEinHistory(businessId);
            }
            return;
          }
          this.pollEinStatus(businessId, attemptsLeft - 1);
        },
        () => this.pollEinStatus(businessId, attemptsLeft - 1)
      );
    }, 2000);
  }

  loadEinHistory(businessId: any) {
    if (!businessId) {
      return;
    }
    this.einHistoryLoading = true;
    this.clientDataService.getEinVerificationHistory(businessId).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        this.einHistoryLoading = false;
        if (json.response.status == 'SUCCESS') {
          this.einHistory = json.data || [];
        }
      },
      (error) => {
        console.log(error);
        this.einHistoryLoading = false;
      }
    );
  }

  getExpiryRowClass(client: any): string {
    if (!client.expiryDate) {
      return '';
    }
    const daysToExpiry = moment(client.expiryDate).startOf('day').diff(moment().startOf('day'), 'days');
    if (daysToExpiry < 0) {
      return 'row-expired';
    }
    if (daysToExpiry <= 7) {
      return 'row-expiring-soon';
    }
    return '';
  }

  showProgressBar() {
    this.messageService.clear();
    this.isLoading = true;
    this.disabled = true;
  }

  hideProgressBar() {
    this.isLoading = false;
    this.disabled = false;
  }

  showErrorMessage(msg: string) {
    this.messageService.add({
      key: 'errMsg',
      severity: 'error',
      detail: msg,
    });
  }

  showMessage(severity: string, msg: string) {
    this.messageService.add({
      key: 'errMsg',
      severity: severity,
      detail: msg,
    });
  }

  showErrorToastMsg(msg: string) {
    this.messageService.add({
      key: 'br',
      severity: 'error',
      summary: 'Error',
      detail: msg,
    });
  }

  showSuccessToastMsg(msg: string) {
    this.messageService.add({
      key: 'br',
      severity: 'success',
      summary: 'Success',
      detail: msg,
    });
  }


  clearFormData() {
    this.messageService.clear('errMsg');
    this.businessName = '';
    this.shortName = '';
    this.address = '';
    this.address2 = '';
    this.city = '';
    this.business_state = '';
    this.zipcode = '';
    this.phone = '';
    this.ein = '';
    this.originalEin = '';
    this.einVerificationStatus = '';
    this.einValidateLoading = false;
    this.einHistory = [];
    this.country = null;
    this.rootUser = null;
    this.newPassword = '';
    this.confirmPassword = '';
  }

  resetUserList() {
    this.searchInputText = '';
    this.currentPage = 1;
    this.paginator?.changePage(0);
    this.listClients(this.currentPage, this.searchInputText);
  }

  onEnterSearchUser(event: any, searchValue: string) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.currentPage = 1;
      this.paginator?.changePage(0);
      this.listClients(this.currentPage, searchValue)
    }, 900);
  }

  onFilterValueChange(event: any) {
    this.listClients(this.currentPage, this.searchInputText);
  }

  formatSubscriptionType(subscriptionType: string): string {
    if (!subscriptionType) {
      return '';
    }
    return subscriptionType.toUpperCase() === 'FREE FOREVER' ? 'FREE' : subscriptionType;
  }

  formatSubscriptionDuration(duration: string): string {
    if (!duration) {
      return '';
    }
    if (duration.toLowerCase() === 'monthly') {
      return 'Monthly';
    }
    if (duration.toLowerCase() === 'yearly') {
      return 'Annual';
    }
    return duration;
  }


  showHideModalDialog(type: string) {
    switch (type) {
      case 'edit_client':
        this.headerName = 'Edit Business';
        this.displayAddEditModal = !this.displayAddEditModal;
        break;
      case 'add_client':
        this.clearFormData();
        this.headerName = 'Add Business';
        this.displayAddEditModal = !this.displayAddEditModal;
        break;
      case 'assign_client':
        this.headerName = 'Assign Twillio Number';
        this.displayChangeModal = !this.displayChangeModal;
        break;
    }
  }

  validateDigitOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressAlphaNumericWithCharacters(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    // Allow numbers, alpahbets
    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }


  showDialogMaximized(event: any, dialog: Dialog) {
    if (this.innerWidth <= 640) {
      dialog.maximized = true;
    }
  }

  paginate(event: any) {
    console.log(event)
    this.currentPage = event.page + 1;
    this.listClients(this.currentPage, this.searchInputText)
  }

  onSortColumn(col: any) {
    if (!col.sortable) {
      return;
    }
    if (this.sortField == col.field) {
      this.sortDirection = this.sortDirection == 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortField = col.field;
      this.sortDirection = 'ASC';
    }
    this.currentPage = 1;
    this.paginator?.changePage(0);
    this.listClients(this.currentPage, this.searchInputText);
  }

  getPrivilege(id: any) {
    return this.privilegeService.getPrivileges(id);
  }

  get state(): string {
    return this.utils.state;
  }


}
